module.exports = __webpack_public_path__ + "static/media/sap.ae003813.png";